export default "__VITE_ASSET__z5UAwogk__"